import React, { useState } from "react";

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));

    const [isLoggedIn, setIsLoggedIn] = useState(
        localStorage.getItem("authToken") ? true : false,
    );
    // 👇 Corrupted/stale localStorage value (jaise literal "undefined" string)
    // ko safely handle karta hai — warna JSON.parse crash kar ke POORI app
    // white-screen kar deta hai. Agar parse fail ho, us key ko clean kar dete hain.
    const safeParse = (key) => {
        const raw = localStorage.getItem(key);
        if (!raw || raw === "undefined" || raw === "null") return null;
        try {
            return JSON.parse(raw);
        } catch (e) {
            localStorage.removeItem(key);
            return null;
        }
    };

    const [loggedInCustomer, setLoggedInCustomer] = useState(() => safeParse("LoggedInCustomer"));
    const [loggedInRental, setLoggedInRental] = useState(() => safeParse("LoggedInRental"));

    const isRentalVerified =
    loggedInRental?.verification_status === "verified";

    const [loggedInMechanic, setLoggedInMechanic] = useState(() => safeParse("LoggedInMechanic"));

    const isMechanicVerified = loggedInMechanic?.verification_status === "verified";

    const [loggedInAdmin, setLoggedInAdmin] = useState();
//////////////////////////////local/////////////////////////////////
    // const [baseUrl] = useState("http://127.0.0.1:8000/api");
    // const [baseUrlForFile] = useState("http://127.0.0.1:8000/storage");

/////////////////////////////////Live //////////////////////////////
    const [baseUrl] = useState("https://smartagrirent.btsportfolio2026.com/backend/public/api");
    const [baseUrlForFile] = useState("https://smartagrirent.btsportfolio2026.com/backend/public/storage");

    const usernameRegExp = new RegExp(/^[A-Za-z0-9]{3,}$/);
    const emailRegExp = new RegExp(/^[A-za-z0-9#$%_!&.?]{5,}@[a-z0-9]{3,}.[a-z0-9.]{2,}$/);
    const passwordRegExp = new RegExp(/^[A-za-z0-9#$%^&_!.?]{8,}$/);
    const phoneNumberRegExp = new RegExp(/^[0-9]{4,4}-[0-9]{7,7}$/);
    const CNICnumberRegExp = new RegExp(/^[0-9]{5,5}-[0-9]{7,7}-[0-9]{1,1}$/);
    const confirmPasswordRegExp = new RegExp(passwordRegExp);
    const regExpChecker = (type, input) => {   
        switch (type) {
            case "username":
                if (!usernameRegExp.test(input)) {
                    return "Username must be at least 5 characters long and contain only letters."
                }
                break;
            case "email":
                if (!emailRegExp.test(input)) {
                    return "Please enter a Valid email address(e.g., example@gmail.com)"
                }
                break;
            case "password":
                if (!passwordRegExp.test(input)) {
                    return "Password must be atleast 8 characters long and can include letters, numbers, and special characters."
                }
                break;
            case "phoneNumber":
                if (!phoneNumberRegExp.test(input)) {
                    return "Phone number must be in format  XXXX-XXXXXXX(e.g., 0300-1234567)"
                }
                break;
            case "CNICnumber":
                if (!CNICnumberRegExp.test(input)) {
                    return "CNIC must be in format XXXXX-XXXXXXX-X(e.g., 12345-1234567-1)"
                }
                break;


        }

    }
    return <AppContext.Provider value={{
        baseUrl, baseUrlForFile, isLoggedIn, setIsLoggedIn, authToken, setAuthToken, regExpChecker, loggedInCustomer, setLoggedInCustomer, loggedInRental, setLoggedInRental, loggedInMechanic, setLoggedInMechanic, loggedInAdmin, setLoggedInAdmin, isRentalVerified, isMechanicVerified 


    }}>
        {children}
    </AppContext.Provider>
}

export default AppContext;
